import React from "react"
import { cn } from "./cn"

// Simple prev/next pager with a results count, used by the list pages
// (Patients, Prescriptions, Transactions, PatientDetail). Owns its own top
// spacing so the gap above it is consistent everywhere. For the numbered
// product-search pager see products/Pagination.js.
const pagerButton = (disabled) =>
  cn(
    "px-4 py-2 rounded-sm font-medium transition-colors",
    disabled
      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
  )

export default function Pagination({
  page,
  totalPages,
  totalCount,
  onPageChange,
  className = "",
}) {
  return (
    <div className={cn("w-full flex justify-between items-center mt-4", className)}>
      <p className="ms-2 mb-0 text-sm text-gray-600">
        {totalCount ? `${totalCount} results` : ""}
      </p>
      <div className="flex gap-1">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(page - 1, 0))}
          disabled={page === 0}
          className={pagerButton(page === 0)}
        >
          Prev
        </button>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages - 1}
          className={pagerButton(page === totalPages - 1)}
        >
          Next
        </button>
      </div>
    </div>
  )
}
